import { GuestProfile, GuestProfileClassifications, Membership } from '@mews-commander/guest-profile';
import { Stack, Typography } from '@optimus-web/core';
import { GuestAvatar } from '../../../common';
import { GuestTagsSection } from './components';

export interface GuestOverviewProps {
    classifications: GuestProfileClassifications;
    loyaltyMemberships: Array<Membership>;
    profile: GuestProfile;
}

export const GuestOverview = ({ classifications, loyaltyMemberships, profile }: GuestOverviewProps) => (
    <Stack itemAlignment="start" spacing="200">
        {profile ? <GuestAvatar fullName={profile?.fullName} imageId={profile?.imageId} size="medium" /> : null}
        <Stack vertical spacing="100">
            {profile?.email ? (
                <Typography textStyle="bodyMediumStrong" variant="primary" wordBreak="break-all" as="div">
                    {profile?.email}
                </Typography>
            ) : null}
            {profile?.phone ? (
                <Typography textStyle="bodyMedium" variant="secondary" as="div">
                    {profile?.phone}
                </Typography>
            ) : null}
            <GuestTagsSection
                loyaltyMembership={loyaltyMemberships?.[0]}
                guestProfileClassifications={classifications}
            />
        </Stack>
    </Stack>
);
